/**
 * What a store product costs the buyer and how it is billed. Warren's rule (4 November 2026, replacing the 14 October
 * amendment's 1.24 multiplier and its DC Compact exception): DC and High Power show Autel's MSRP, plus Autel's
 * pre-commissioning fee (parts DCFPRE and DCHPPRE), plus a US$475 margin. Both checkouts bill the same total as two
 * lines, the hardware at MSRP and the pre-commissioning amount.
 *
 * The amount is the product's own commissioning_cents, so it changes without touching msrp_cents: the public price is
 * the sum of the two. price_cents is that sum as stored, kept for anything reading the row directly. A row with no
 * msrp_cents yet has the MSRP inside price_cents, so the hardware is the difference and its public price stays what
 * the row says. Other tiers have no commissioning line, exactly as before.
 */
export const STORE_COMMISSIONING_MARGIN_CENTS = 47_500;
/** Autel's POs read this fee when they are read, sent ones included: autelPrecommissionPart in ../procurement.ts says what to check before changing it. */
export const STORE_AUTEL_COMMISSIONING_FEE_CENTS = { dc: 135_000, high_power: 270_000 };
/** Every Product field the price reads. A projection that prices a product spreads this, so none of them can drift. */
export const STORE_PRICE_FIELDS = { tier: 1, price_cents: 1, msrp_cents: 1, commissioning_cents: 1, commissioning_cost_cents: 1 };
/** Autel's fee for a tier, and what the buyer pays for it: the fee plus EVI's margin. Zero on a tier with no line. */
export function storeCommissioningForTier(tier) {
    const fee = STORE_AUTEL_COMMISSIONING_FEE_CENTS[tier] ?? 0;
    return { autel_fee_cents: fee, billed_cents: fee ? fee + STORE_COMMISSIONING_MARGIN_CENTS : 0 };
}
export function storeCommissioningPrice(product) {
    const defaultFee = STORE_AUTEL_COMMISSIONING_FEE_CENTS[product.tier] ?? 0;
    const embedded = product.commissioning_cents ?? 0;
    const billed = defaultFee ? embedded : 0;
    const hardware = product.msrp_cents ?? product.price_cents - embedded;
    const cost = billed ? product.commissioning_cost_cents ?? defaultFee : 0;
    if (![hardware, embedded, cost].every(n => Number.isSafeInteger(n) && n >= 0))
        throw new Error('Commissioning price evidence is invalid.');
    return { hardware_cents: hardware, billed_cents: billed, commissioning_cost_cents: cost, total_cents: hardware + billed };
}
//# sourceMappingURL=store-commissioning-price.js.map